import { CircularProgress, Stack, styled } from "@mui/material";
import { FormErrorMessage } from "../FormErrorMessage";
import { MuiImage as BaseMuiImage } from "../MuiImage";
import { BodyTextM, HeadingL } from "../Typography";
import { InternalButtonLink } from "../InternalButtonLink";

export const Wrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        textAlign: "left",
        flexDirection: "column",
    }),
);

export const CompactWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        pt: 2,
    }),
);

export const ImageWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        overflow: "hidden",
        p: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }),
);

export const DefaultImage = styled(BaseMuiImage)(({ theme }) =>
    theme.unstable_sx({
        height: "auto",
        width: "auto",
    }),
);

export const Title = styled(HeadingL)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
        mb: theme.spacing(3),
    }),
);

export const BodyPlain = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(4),
    }),
);

export const BodyBanner = styled(FormErrorMessage)(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(4),
    }),
);

export const DocumentsBanner = styled(FormErrorMessage)(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(3),
    }),
);

export const AttentionBlock = styled(FormErrorMessage)(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(5),
    }),
);

export const LoadingWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        my: theme.spacing(25),
    }),
);

export const Spinner = styled(CircularProgress)(() => ({}));

export const ActionWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mt: theme.spacing(5),
        flexDirection: "row",
        justifyContent: "flex-start",
    }),
);

export const ActionButton = styled(InternalButtonLink)(({ theme }) => ({}));
